import { motion } from 'framer-motion';

export function SpecialOffer() {
  const scrollToQuote = () => {
    const el = document.getElementById('get-quote') || document.getElementById('quote-form');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const perks = [
    { icon: 'ri-pencil-ruler-2-line', text: 'Free Design Consultation' },
    { icon: 'ri-timer-flash-line', text: 'Fast Turnaround Guaranteed' },
    { icon: 'ri-shield-check-line', text: 'Premium Materials Used' },
    { icon: 'ri-install-line', text: 'Professional Installation Included' },
  ];

  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/38a47a707a35e21484ef4d95e191d61a.jpg"
          alt="Signarama Arlington Sign Shop"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-950/95 via-gray-950/85 to-gray-950/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-flex items-center space-x-2 bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
              <i className="ri-fire-line"></i>
              <span>LIMITED TIME OFFER</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
              Get{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-orange-400">
                15% Off
              </span>{' '}
              Your First Order
            </h2>
            <p className="text-gray-300 text-lg mb-8 leading-relaxed">
              New Arlington customers receive 15% off their first signage project. Vehicle wraps,
              storefront signs, banners, or trade show displays — claim your discount today.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10">
              {perks.map((perk, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-teal-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${perk.icon} text-teal-400 text-sm`}></i>
                  </div>
                  <span className="text-gray-200 text-sm font-medium">{perk.text}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <button
                onClick={scrollToQuote}
                className="px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold rounded-full hover:from-orange-600 hover:to-orange-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Claim Your Discount Now
              </button>
              <a
                href="tel:817-860-9310"
                className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-phone-line text-teal-400"></i>
                <span className="font-semibold">817-860-9310</span>
              </a>
            </div>
            <p className="text-gray-500 text-xs mt-4">
              *Offer valid for new customers only. Minimum order value applies.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="hidden lg:block"
          >
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8">
              <h3 className="text-white text-xl font-bold mb-6">What&apos;s Included</h3>
              <div className="space-y-4">
                {[
                  { title: 'Free Consultation', desc: 'In-person or virtual project review' },
                  { title: 'Custom Design Proof', desc: 'Full-color proof before production' },
                  { title: 'Premium Production', desc: '3M/Avery Dennison materials' },
                  { title: 'Professional Install', desc: 'Certified installation crew' },
                  { title: '15% New Client Savings', desc: 'Applied to your first order total' },
                ].map((item, index) => (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <div>
                      <p className="text-white font-semibold text-sm">{item.title}</p>
                      <p className="text-gray-400 text-xs">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
